import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import Keywords from '../views/Keywords'
import Activity from '../views/dashboards/Activity'
import Counters from '../views/dashboards/Counters'
import Customers from '../views/dashboards/Customers'
import Campaigns from '../views/dashboards/Campaigns'
import KeywordsReport from '../views/reports/KeywordsReport'
import Gallons from '../views/dashboards/Gallons'
import Inquires from '../views/dashboards/Inquires'
import MonthlyActivity from '../views/dashboards/MonthlyActivity'
import MonthlyStateActivity from '../views/dashboards/MonthlyStateActivity'
import Movement from '../views/reports/Movement'
import MarketingReport from '../views/reports/MarketingReport'
import AggregatedReport from '../views/reports/AggregatedReport'
import EfficiencyReport from '../views/reports/EfficiencyReport'
import CopperReport from '../views/reports/CopperReport'
import PotentialGallonReport from '../views/reports/PotentialGallonReport'
import SalesReport from '../views/reports/SalesReport'
import GeoSalesReport from '../views/reports/GeoSalesReport'
import KeywordMapping from '../views/settings/KeywordMapping'
import SettingStatus from '../views/settings/Status'
import SettingRank from '../views/settings/SettingRank'
import CruiseCampaign from '../views/settings/CruiseCampaign'
import Login from '../views/Login'
import ForgotPassword from '../views/ForgotPassword'
import RestorePassword from '../views/RestorePassword'
import CompanyManagement from '../views/administrations/CompanyManagement'
import UserManagement from '../views/administrations/UserManagement'
import InternalStatistic from '../views/administrations/InternalStatistic'
import Logs from '../views/administrations/Logs'
import LogsJobComponent from "../views/administrations/LogsJobComponent";
import CallCenter from "../views/dashboards/CallCenter";
import SendInBlue from '../views/reports/SendInBlue'
import AllCustomers from '../views/reports/AllCustomers'
import CallRailReport from '../views/reports/CallRailReport'
import WebInqureReport from '../views/reports/WebInqureReport'
import ImportGai from '../views/administrations/ImportGai'
import MarketingSummaryReport from '../views/reports/MarketingSummaryReport'
import CallRailPivotReport from "@/views/reports/CallRailPivotReport.vue";
import SurewayInfo from "@/views/dashboards/SurewayInfo.vue";
import ruralBuildOffContacts from "@/views/dashboards/RuralBuildOffContacts.vue";
import Sellnetics_Applicators from "@/views/dashboards/Sellnetics_Applicators.vue";
import Sellnetics_Estimations from "@/views/dashboards/Sellnetics_Estimations.vue";


Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/cruise-campaigns',
      name: 'index',
      component: Home,
      meta: { requiresAuth: true, title: 'Home' },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
    },
    {
      path: '/restore-password/:hash',
      name: 'restore-password',
      component: RestorePassword,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true, title: 'Home' }
    },
    {
      path: '/cruise-campaigns',
      name: 'keywords',
      component: Keywords,
      meta: { requiresAuth: true, title: 'Cruise Campaigns' }
    },
    {
      path: '/keyword-attribution',
      name: 'movement',
      component: Movement,
      meta: { requiresAuth: true, title: 'Keyword Attribution' }
    },
    {
      path: '/email-campaigns-attribution',
      name: 'sendinblue',
      component: SendInBlue,
      meta: { requiresAuth: true, title: 'Email Marketing Attribution' }
    },
    {
      path: '/cost-per-gallon',
      name: 'activity',
      component: Activity,
      meta: { requiresAuth: true, title: 'Cost per Gallon' }
    },

    {
      path: '/sellnetics',
      name:'sellneticsapp',
      component:ruralBuildOffContacts,
      meta:{requiresAuth: true, title: 'FO Contacts' }
    },

    {
      path: '/fo-contacts',
      name:'buildingofficial',
      component:ruralBuildOffContacts,
      meta:{requiresAuth: true, title: 'FO Contacts' }
    },
    {
      path: '/applicators',
      name:'applicators-req',
      component:Sellnetics_Applicators,
      meta:{requiresAuth: true, title: 'Applicators' }
    },
    {
      path: '/estimations',
      name:'estimations',
      component:Sellnetics_Estimations,
      meta:{requiresAuth: true, title: 'Estimations' }
    },

      /*
    {
      path: '/building-arhitect',
      name:'buildingarhitect',
      component:ruralBuildOffArhitect,
      meta:{requiresAuth: true, title: 'Arhitects' }
    },*/
    {
      path: '/crm-customers',
      name: 'allCustomers',
      component: AllCustomers,
      meta: { requiresAuth: true, title: 'CRM Customers' }
    },
    {
      path: '/general-metrics',
      name: 'counters',
      component: Counters,
      meta: { requiresAuth: true, title: 'General Metrics Overview' }
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers,
      meta: { requiresAuth: true, title: 'Customers Report' }
    },
    {
      path:'/surveyinfo',
      name:'surveyinfo',
      component: SurewayInfo,
      meta: { requiresAuth: true, title: 'Survey Report' }
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: Campaigns,
      meta: { requiresAuth: true, title: 'Campaigns' }
    },
    {
      path: '/keywords-report',
      name: 'keywords-report',
      component: KeywordsReport,
      meta: { requiresAuth: true, title: 'Keywords Report' }
    },
    {
      path: '/gallons',
      name: 'gallons',
      component: Gallons,
      meta: { requiresAuth: true, title: 'Gallons Activity' }
    },
    {
      path: '/inquires',
      name: 'inquires',
      component: Inquires,
      meta: { requiresAuth: true, title: 'Web Inquires' }
    },
    {
      path: '/monthly-activity',
      name: 'monthly-activity',
      component: MonthlyActivity,
      meta: { requiresAuth: true, title: 'Monthly Activity' }
    },
    {
      path: '/monthly-state-activity',
      name: 'monthly-state-activity',
      component: MonthlyStateActivity,
      meta: { requiresAuth: true, title: 'Sales Activity per Geo Area' }
    },
    {
      path: '/marketing-adwords',
      name: 'marketing-adwords',
      component: MarketingReport,
      meta: { requiresAuth: true, title: 'Google Ads Marketing Report' },
      props: { ads: 'adwords' }
    },
    {
      path: '/marketing-bing',
      name: 'marketing-bing',
      component: MarketingReport,
      meta: { requiresAuth: true, title: 'Bing Ads Marketing Report' },
      props: { ads: 'bing' }
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: AggregatedReport,
      meta: { requiresAuth: true, title: 'Marketing Report' },
    },
    {
      path: '/marketing-summary',
      name: 'marketing-summary',
      component: MarketingSummaryReport,
      meta: { requiresAuth: true, title: 'Marketing Activity' },
    },
    {
      path: '/marketing-attribution',
      name: 'efficiency',
      component: EfficiencyReport,
      meta: { requiresAuth: true, title: 'Marketing Channel Attribution' }
    },
    {
      path: '/crm-report',
      name: 'copper-report',
      component: CopperReport,
      meta: { requiresAuth: true, title: 'CRM Report' }
    },
    {
      path: '/potential-gallon',
      name: 'potential-gallon',
      component: PotentialGallonReport,
      meta: { requiresAuth: true, title: 'Potential Quotes' }
    },
    {
      path: '/callrail',
      name: 'callrail',
      component: CallRailReport,
      meta: { requiresAuth: true, title: 'CallRail Report' }
    },
    {
      path: '/web-inquiries-report',
      name: 'web-inquiries-report',
      component: WebInqureReport,
      meta: { requiresAuth: true, title: 'Web inquiries Report' }
    },
    {
      path: '/call-center',
      name: 'call-center',
      component: CallCenter,
      meta: { requiresAuth: true, title: 'Call Center' }
    },
    {
      path: '/call-report',
      name: 'call-report',
      component: CallRailPivotReport,
      meta: { requiresAuth: true, title: 'Call and Web Inquires Report' }
    },
    {
      path: '/sales',
      name: 'sales',
      component: SalesReport,
      meta: { requiresAuth: true, title: 'Sales Report' }
    },
    {
      path: '/keyword-mapping',
      name: 'mapping',
      component: KeywordMapping,
      meta: { requiresAuth: true, title: 'Keyword Mapping' }
    },
    {
      path: '/status',
      name: 'status',
      component: SettingStatus,
      meta: { requiresAuth: true, title: 'Status' }
    },
    {
      path: '/setting-rank',
      name: 'setting-rank',
      component: SettingRank,
      meta: { requiresAuth: true, title: 'Rank' }
    },
    {
      path: '/cruise-campaign',
      name: 'cruise-campaign',
      component: CruiseCampaign,
      meta: { requiresAuth: true, title: 'Cruise Campaign' }
    },
    {
      path: '/geo-sales',
      name: 'geo',
      component: GeoSalesReport,
      meta: { requiresAuth: true, title: 'Geo Sales Report' }
    },
    {
      path: '/company-management',
      name: 'company-management',
      component: CompanyManagement,
      meta: { requiresAuth: true, title: 'Company Management' }
    },
    {
      path: '/import-gai',
      name: 'import-gai',
      component: ImportGai,
      meta: { requiresAuth: true, title: 'Import Auction Insights' }
    },
    {
      path: '/user-management',
      name: 'user-management',
      component: UserManagement,
      meta: { requiresAuth: true, title: 'User Management' }
    },
    {
      path: '/internal-stats',
      name: 'internal-stats',
      component: InternalStatistic,
      meta: { requiresAuth: true, title: 'Internal Statistic' }
    },
    {
      path: '/logs',
      name: 'logs',
      component: Logs,
      meta: { requiresAuth: true, title: 'Logs' }
    },
    {
      path:'/logs-job-component',
      name:'logs jobs',
      component: LogsJobComponent,
      meta:{ requiresAuth: true, title: 'Logs' }
    },
  ]
})

router.beforeEach((to, from, next) => {
	let token = localStorage.getItem('token');
	let requireAuth = to.matched.some(record => record.meta.requiresAuth);

	if (!requireAuth) {
		next();
	}

	if (requireAuth && !token) {
		next('/login');
	}

	if (to.path === '/login') {
		if (token) {
			next('/');
		}
		else {
			next();
		}
	}

	if (requireAuth && token) {
		next();
	}
});

router.afterEach((to) => {
  Vue.nextTick( () => {
    document.title = to.meta.title ? to.meta.title : 'FlameOFF Navigator';
    window.scrollTo(0, 0);
  });
})


export default router
